function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1.37142857 C4.33914109,1.37142857 1.37142857,4.33914109 1.37142857,8 C1.37142857,11.6608589 4.33914109,14.6285714 8,14.6285714 C11.6608589,14.6285714 14.6285714,11.6608589 14.6285714,8 C14.6285714,4.33914109 11.6608589,1.37142857 8,1.37142857 Z M12.2007625,3.72058732 L9.29152312,9.2894927 L3.72261774,12.198732 L6.63185707,6.62982665 L12.2007625,3.72058732 Z M7.49657611,7.49454569 C7.21539862,7.77572318 7.21539862,8.23160196 7.49657611,8.51277945 C7.7777536,8.79395694 8.23363239,8.79395694 8.51480988,8.51277945 C8.79598737,8.23160196 8.79598737,7.77572318 8.51480988,7.49454569 C8.23363239,7.2133682 7.7777536,7.2133682 7.49657611,7.49454569 Z",
  id: "\\u5F62\\u72B6"
});

var SvgNavDrainage = function SvgNavDrainage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNavDrainage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_drainage.dd222f83.svg";
export { ForwardRef as ReactComponent };